import React, { useContext } from 'react';
import ThemeContext from '../contexts/ThemeContext';
import '../styles/ThemeToggle.css';

const ThemeToggle = () => {
  const context = useContext(ThemeContext);
  
  if (!context) {
    return <div>Loading theme...</div>;
  }
  
  const { toggleTheme, theme } = context;
  const isLight = theme === 'light';

  return (
    <button
      className="theme-toggle"
      onClick={toggleTheme}
      aria-label={`Alternar para tema ${isLight ? 'escuro' : 'claro'}`}
      title={`Alternar para tema ${isLight ? 'escuro' : 'claro'}`}
    >
      <div className="theme-toggle-track">
        <div className="theme-toggle-thumb">
          <i className={`fas ${isLight ? 'fa-sun' : 'fa-moon'} theme-icon`}></i>
        </div>
      </div>
    </button>
  );
};

export default ThemeToggle;